import React from "react";

export const RightShortIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="26"
        height="27"
        viewBox="0 0 26 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M11.3002 26.5115C11.9523 27.1628 13.0095 27.1628 13.6615 26.5115L25.5073 14.6783C26.1593 14.027 26.1593 12.9709 25.5073 12.3196C24.8552 11.6682 23.798 11.6682 23.146 12.3196L11.3002 24.1527C10.6482 24.8041 10.6482 25.8601 11.3002 26.5115Z"
            fill="currentColor"
        />
        <path
            d="M11.2949 0.488519C10.6428 1.13988 10.6428 2.19594 11.2949 2.8473L23.1416 14.6814C23.7936 15.3327 24.8508 15.3327 25.5029 14.6814C26.1549 14.03 26.1549 12.974 25.5029 12.3226L13.6562 0.48852C13.0041 -0.162839 11.9469 -0.16284 11.2949 0.488519Z"
            fill="currentColor"
        />
        <path
            d="M0 13.498C0 12.5768 0.747545 11.8301 1.66969 11.8301H24.3303C25.2525 11.8301 26 12.5768 26 13.498C26 14.4191 25.2525 15.1659 24.3303 15.1659H1.66969C0.747545 15.1659 0 14.4191 0 13.498Z"
            fill="currentColor"
        />
    </svg>
);
